<template>
  <div class="basic-content">
    <component :is="component" v-bind="$attrs"/>
  </div>
</template>

<script>
import approvalForm from './approvalForm'
import approvalConfig from './approvalConfig'

export default {
  name: 'approvalContent',
  components: {
    approvalForm,
    approvalConfig,
  },
  computed: {
    component() {
      const { active } = this.$attrs
      return Number(active) === 0 ? 'approvalForm' : 'approvalConfig'
    },
  },
}
</script>

<style lang="scss" scoped>
.basic-content {
  margin-top: 84px;
}
</style>
